package koala.markdown

import koala.modifier.Class
import koala.model.EditorStyle

/** The classes of rendered markdown. */
object MarkdownStyle {
    val Container = Class("md")
    val Block = Container.withBemElement("block")
    val Paragraph = Container.withBemElement("paragraph")
    val UnorderedList = Container.withBemElement("unordered-list")
    val OrderedList = Container.withBemElement("ordered-list")
    val InlineImage = Container.withBemElement("inline-image")
    val InlineImageCaption = Container.withBemElement("inline-image-caption")
    val BlockImage = Container.withBemElement("block-image")
    val Blockquote = Container.withBemElement("blockquote")
}

val FloatLeft = Class("float-left")
val FloatRight = Class("float-right")

// language="CSS"
val MarkdownCss get() = with(MarkdownStyle) { """

$Container {
    code {
        font-size: 0.875em;
        padding: 0.1em 0.3em 0.05em;
        background-color: var(--void-bg);
        border: 1px solid var(--outline-low-fg);
        border-radius: 4px;
        color: var(--sea-green-fg);
    }
}

$FloatRight {
    float: right;
    clear: right;
}

$FloatLeft {
    float: left;
    clear: left;
}

$Block > * + * {
    margin-top: var(--unit-2);
}

$OrderedList {
    padding-inline-start: var(--unit-3);
}

$UnorderedList {
    list-style: none;
}

$InlineImage {
    max-width: 33%;
    height: auto;
    display: inline-block;
}

$Paragraph {
    white-space: pre-line;
}

$BlockImage figcaption,
$InlineImageCaption {
    display: block;
    text-align: center;
    font-style: italic;
    font-size: 1rem;
    color: rgba(var(--ink), .7);
}

$BlockImage {
    text-align: center;
    
    img {
        margin: auto;
    }
}

${EditorStyle.BlockType.selector(ContentBlock.BlockQuote)},
blockquote {
    margin-inline-start: 1rem;
    padding-inline-start: 1rem;
    border-inline-start: 2px solid var(--primary-fg);
}

$Blockquote {
    figcaption {
        text-align: right;
        opacity: var(--opacity-high);
    }
}

""" }